import React from "react";
import "./style.css";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../CtaButton";

const Footer = () => {
  // ARABIC TRANSLATION

  const location = useLocation();

  const { t } = useTranslation("footer");
  const mainHeadings = t("Headings", { returnObjects: true });
  const services = t("services", { returnObjects: true });
  const company = t("company", { returnObjects: true });
  const career = t("career", { returnObjects: true });
  const trustedBy = t("trustedBy", { returnObjects: true });
  const socialLinks = t("socialLinks", { returnObjects: true });
  const copyright = t("copyright", { returnObjects: true });
  const copyrightLinks = t("copyrightLinks", { returnObjects: true });
  const modal = t("modal", { returnObjects: true });
  const locations = t("locations", { returnObjects: true });
  const buttons = t("buttons", { returnObjects: true });

  const { t: footerLocations } = useTranslation("ksaHome");
  const ksaHomeourLocations = footerLocations("ourLocations", {
    returnObjects: true,
  });

  return (
    <>
      <div className={`footer-box ${location.pathname === "/contact-us" ? 'contact-us-footer' : ""}`}>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-4">
              <h3 className="footer-heading">{mainHeadings[0].text}</h3>
              <ul className="footer-list">
                {services.map((item, index) => (
                  <li key={index}>
                    <Link to={item.path}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4">
              <h3 className="footer-heading">{mainHeadings[1].text}</h3>
              <ul className="footer-list">
                {company.map((item, index) => (
                  <li key={index}>
                    {item.highlight ? (
                      <Link to={item.path}>
                        <span className="active-box">
                          {item.label}{" "}
                          <i className="fa-solid fa-arrow-right-long"></i>
                        </span>
                      </Link>
                    ) : (
                      <Link to={item.path}>{item.label}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-xl-2 col-lg-2 col-md-4">
              <h3 className="footer-heading">{mainHeadings[2].text}</h3>
              <ul className="footer-list footer-list-industries-scroller">
                {career.map((item, index) => (
                  <li key={index}>
                    <a href={`${item.path}`} target="_blank">
                      {item?.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-12">
              <div className="trust-box-text mb-5">
                <h3 className="footer-heading">{mainHeadings[3].text}</h3>
                <div className="d-flex flex-wrap mt-4 gap-3">
                  <Button
                    text={buttons?.contactUs}
                    link="/contact-us"
                    appearance="outline"
                  />
                  <Button
                    text={buttons?.scheduleACall}
                    link="https://calendly.com/bitsclan-it/30min?"
                    newTab
                    hideIcon={true}
                  />
                </div>

                <div className="footer-phone-number">
                  <a href="tel:+13156668052">
                    <i class="fa-solid fa-phone me-1"></i> +1 (315) 666-8052
                  </a>
                </div>
              </div>

              <div className="trust-box-text">
                <h3>{mainHeadings[4].text}</h3>
                <div className="trust-logo-box">
                  {trustedBy.map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={item.img} alt={`${item.name} Footer Logo`} />
                    </a>
                  ))}
                </div>
              </div>

              <div className="get-social-text">
                <h3>{mainHeadings[5].text}</h3>
                <ul className="social-icon">
                  {socialLinks.map((item, index) => (
                    <li key={index}>
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className={item.icon}></i>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            {locations?.map((item, index) => {
              return (
                <div
                  className="col-xl-3 col-lg-3 col-md-6 mb-3 space-bottom p-0"
                  key={index}
                >
                  <div className="location-card-box location-footer-cards">
                    <div className="location-icon">
                      <img src={`/images/address-icons/${item?.icon}`} alt={item?.altText} />
                    </div>
                    <h3>{item?.title}</h3>
                    <h4>{item?.location}</h4>
                    <a href={`${item?.addressLink || "#"}`} target="_blank">
                      {item?.address}
                    </a>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="row border-top-footer">
            <div className="col-md-12">
              <div className="copyright-box-main">
                <p>{copyright}</p>
                <ul className="footer-list copyright-links-text">
                  {copyrightLinks?.map((item, index) => {
                    return (
                      <li key={index}>
                        <Link to={item?.path}>{item?.label}</Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id={modal.id}
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabIndex="-1"
      >
        <div className="modal-dialog shedule-call-model-box modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-center">
                <img src={modal.image} width={300} alt={modal.imageAlt} />
              </div>
              <h4
                style={{
                  fontSize: "42px",
                  textAlign: "center",
                  color: "#000000",
                }}
                className="mt-2"
              >
                {modal.title}
              </h4>
              <h4
                style={{
                  fontSize: "42px",
                  textAlign: "center",
                  color: "#000000",
                }}
              >
                {modal.message}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
